import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// Performance monitoring for mobile
if (typeof window !== 'undefined') {
  window.__SOLVIBE_VERSION = "v14-20260606";
  if ('performance' in window) {
    // Mark app start
    performance.mark('app-start');
  }
}

// Register service worker for PWA caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Use concurrent mode features for better mobile performance
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Mark render complete for performance tracking
if (typeof window !== 'undefined' && 'performance' in window) {
  window.addEventListener('load', () => {
    performance.mark('app-loaded');
    
    // Measure initial load time
    try {
      performance.measure('app-load-time', 'app-start', 'app-loaded');
    } catch (e) {
      // Ignore if measurement fails
    }
  });
}
